import { render } from "./TheMbNameAndComment.vue?vue&type=template&id=723a168c"
import script from "./TheMbNameAndComment.vue?vue&type=script&lang=js"
export * from "./TheMbNameAndComment.vue?vue&type=script&lang=js"
script.render = render

export default script